import { store } from "../../../redux/store";
import { BRAND } from "@core/brand/brand-config";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";
import LocalStorageService from "../../../core/services/local-storage.service";
import { getComplianceUrl } from "../../../utils/complianceUrl";
import { getProductMasterURL } from "../../../utils/getProductMatserUrl";
import { getHSCodeClassificationUrl } from "../../../utils/hsCodeClassificationUrl";
import { getSanctionsUrl } from "../../../utils/sanctionsUrl";
import { getUmsDashboardUrl } from "../../../utils/umsDashboardUrl";
import { getTradeMapUrl } from "@utils/tradeMapUrl";
import { getFinScreenerUrl } from "../../../utils//getFinScreenerUrl";
import { getSourceAtlasUrl } from "@utils/sourceAtlasUrl";
import { getActualIntelUrl } from "@utils/intelUrl";

const { allAppsIntel, allAppsSourceAtlas, allAppsHs_classifier, allAppsLandedCostCalculator, allAppsTradeReference, allAppsProductMaster, allAppsSanctionsScreener, allAppsUserManagementSystem, allAppsSupplyChain } = trackingEventDictionary;

const localStorageService = LocalStorageService.getService();

export const productDropdownConfig = () => {
  let token = localStorageService.getAccessToken();
  let session = localStorageService.getSessionID();
  let expiry = localStorageService.getExpiryDate() || localStorageService.getSessionExpiryDate();

  const authParams = "?T=" + token + "&I=" + session + "&D=" + expiry;
  const selfRedirectionUrl = window.location.pathname === "/glossary" ? "/all-country-shipments" : "";
  const isSourceAtlasBuild = BRAND.key === "source_atlas";
  const sourceAtlasDeploymentUrl = getSourceAtlasUrl();

  return token && session && expiry
    ? {
        intel: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658586/trade%20compliance/trademo_intel_xokun3.svg",
          redirectionKey: "intel",
          redirectionUrl: isSourceAtlasBuild ? getActualIntelUrl() + "intel" + authParams + "&P=intel" : selfRedirectionUrl,
          pendo_event: allAppsIntel,
        },
        source_atlas: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1787037875/intel/misc/Source_Atlas_All_apps_dahh5x.svg",
          redirectionKey: "source_atlas",
          redirectionUrl: isSourceAtlasBuild ? selfRedirectionUrl : sourceAtlasDeploymentUrl + "intel" + authParams + "&P=source_atlas",
          pendo_event: allAppsSourceAtlas,
        },
        sanctions: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658583/trade%20compliance/sanctions_screener_pesy2b.svg",
          redirectionKey: "sanctions_screener",
          redirectionUrl: getSanctionsUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=sanctions",
          pendo_event: allAppsSanctionsScreener,
        },
        trade_reference: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658585/trade%20compliance/trade_ref_cdotlp.svg",
          redirectionKey: "trade_reference",
          redirectionUrl: getComplianceUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=trade-compliance&Tab=classify",
          pendo_event: allAppsTradeReference,
        },
        hs_classifier: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658574/trade%20compliance/hs_classifier_tseyjp.svg",
          redirectionKey: "hs_classifier",
          redirectionUrl: getHSCodeClassificationUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=hs-code-classification&F=gtm",
          pendo_event: allAppsHs_classifier,
        },
        hs_classifier_ai: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658574/trade%20compliance/hs_classifier_tseyjp.svg",
          redirectionKey: "hs_classifier",
          redirectionUrl: getHSCodeClassificationUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=hs-code-classification&F=gtm&tab=chatbot",
          pendo_event: allAppsHs_classifier,
        },
        landed_cost: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658581/trade%20compliance/landed_cost_calculator_gci8pf.svg",
          redirectionKey: "landed_cost_calculator",
          redirectionUrl: getComplianceUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=trade-compliance&Tab=landedcostcalculator",
          pendo_event: allAppsLandedCostCalculator,
        },
        product_master: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658582/trade%20compliance/product_master_f1bugz.svg",
          redirectionKey: "product_master",
          redirectionUrl: getProductMasterURL() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=product-master&N=",
          pendo_event: allAppsProductMaster,
        },
        trademap: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1715335533/intel/icons/trademo_map_ltxuo7.svg",
          redirectionKey: "trademap",
          redirectionUrl: getTradeMapUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=trademap",
          pendo_event: allAppsSupplyChain,
        },
        tradescreen: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1726134122/intel/icons/fin_screen_zqywy1.svg",
          redirectionKey: "tradescreen",
          redirectionUrl: getFinScreenerUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=tradescreen&N=",
        },
      }
    : null;
};

export const umsRedirection = () => {
  let userData = store.getState().userDetails.userData;
  let token = localStorageService.getAccessToken();
  let session = localStorageService.getSessionID();
  let expiry = localStorageService.getExpiryDate() || localStorageService.getSessionExpiryDate();

  return token && session && expiry
    ? {
        title: "User Management System",
        mainKey: "userManagement",
        subProductList: [],
        redirectionKey: "user_management_system",
        redirectionUrl: getUmsDashboardUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=ums-dashboard" + "&UserId=" + userData.userId + "&OrganisationId=" + userData.organisationId + "&isInternalAdmin=" + userData.isInternalAdmin + "&isInternalUser=" + userData.isInternalUser + "&isAdmin=" + userData.isAdmin + "&P=" + userData.productArr,
        pendo_event: allAppsUserManagementSystem,
      }
    : {};
};
